import { useEffect, useRef } from 'react';

/**
 * Tells an ancestor that lookups cannot be served.
 *
 * This is the provider's one effect, and it exists because the condition is only
 * knowable while rendering — a key that never arrived, a vendor that answered
 * with a cut-off — while notifying a component above cannot happen there.
 *
 * The announcement is keyed on the outage alone. Hosts pass an inline arrow
 * (CheckAvailabilityDialog does), so keying it on the callback's identity as well
 * re-announced the same outage on every one of their renders.
 */
export const useLookupUnavailableNotice = (unavailable: boolean, notify?: () => void): void => {
  const notifyRef = useRef(notify);

  useEffect(() => {
    notifyRef.current = notify;
  }, [notify]);

  useEffect(() => {
    if (unavailable) notifyRef.current?.();
  }, [unavailable]);
};
